module.exports = __webpack_public_path__ + "02_hige_gray.3ca376d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/02_hige_gray.png
// module id = bEjW
// module chunks = 0